import { parseVideoEmbed } from "@/lib/video-embed";

/**
 * Intro video na javnom profilu terapeuta. Uploadovan fajl (/uploads/...) ide u
 * <video>; YouTube/Vimeo link u iframe, i to samo kroz normalizovan embed URL iz
 * parseVideoEmbed, nikad sirovi uneseni link. Link koji se ne prepozna (stari
 * podaci) se ne prikazuje, umjesto praznog playera.
 */
export function resolveIntroVideo(url: string | null | undefined):
  | { kind: "upload"; src: string }
  | { kind: "embed"; src: string }
  | null {
  const value = url?.trim();
  if (!value) return null;
  if (value.startsWith("/uploads/")) return { kind: "upload", src: value };
  const embed = parseVideoEmbed(value);
  return embed ? { kind: "embed", src: embed.embedUrl } : null;
}

export function TherapistIntroVideo({ url, title }: { url: string; title: string }) {
  const video = resolveIntroVideo(url);
  if (!video) return null;
  return (
    <div className="aspect-video w-full overflow-hidden rounded-xl bg-black">
      {video.kind === "embed" ? (
        <iframe
          src={video.src}
          title={title}
          className="h-full w-full"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
          loading="lazy"
        />
      ) : (
        <video src={video.src} controls playsInline preload="metadata" className="h-full w-full" />
      )}
    </div>
  );
}
